<template>
    <div>
        <swiper
            :modules="modules"
            :slides-per-view="1"
            :space-between="8"
            :speed="700"
            :loop="true"
            :pagination="{
                type: 'bullets',
                clickable: 'true',
            }"
            :enabled="true"
            :initialSlide="current"
            @swiper="setMobileSwiper"
            @slideChange="onSlideChange"
        >
            <swiper-slide v-for="(item) in sliderData">
                <render-vnode :v-node="item"/>
            </swiper-slide>
        </swiper>
    </div>
</template>

<script>
import {Autoplay, Pagination, Navigation} from "swiper";
import {Swiper, SwiperSlide} from "swiper/vue";
import {ref} from "vue";

export default {
    name: "thumb-nail-slider-main-slider-mobile",
    components: {
        Swiper,
        SwiperSlide,
    },
    props: {
        sliderData: {
            type: Object,
            required: true
        },
        current: {
            type: Number,
            required: true
        }
    },
    setup(props) {
        const mobileSwiper = ref(null);
        const sliderData = props.sliderData;
        const current = props.current;

        const setMobileSwiper = (swiper) => {
            mobileSwiper.value = swiper;
        };

        const onSlideChange = (swiper) => {
            if (swiper.realIndex !== current.value) {
                swiper.slideToLoop(swiper.realIndex);
            }
        };

        return {
            mobileSwiper,
            sliderData,
            current,
            setMobileSwiper,
            onSlideChange,
            modules: [Autoplay, Pagination, Navigation],
        }
    }
};
</script>
